import styled from "styled-components";
import { PageDescription } from "../../components";

export const StyledPageDescription = styled(PageDescription)`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 70%;
  }
`;

export const StyledTabsWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.md};
`;
